module.exports = __webpack_public_path__ + "static/img/zt5888335.50607fd0.png";